import { h } from 'preact';
import { joinClasses } from 'utils/utils';

import GoToMediaButton from 'components/media/goToMediaButton';
import SynopsisEditor from 'components/editor/movies/synopsis/synopsis';
import SelectableSection from 'components/editor/selectableSection';
import { formatReleaseDate } from 'components/editor/pages/focus/landing/utils';

import s from 'components/editor/movies/synopsis/synopsisFocus.sss';

export default class FocusSynopsisEditor extends SynopsisEditor {
	s = s;

	// ===============================
	// VISUAL
	// ===============================

	renderSynopsis() {
		// Format the date and genre line
		const releaseDate = formatReleaseDate(this.movie.dates?.release) || null;
		const frontendGenre = this.movie.genre || null;
		// Only show date/genre for non-placeholders
		const dateGenreText = !this.movie.placeholder && [releaseDate, frontendGenre].filter(Boolean).join(' | ');

		return (
			<div class={s.synopsisTextWrapper}>
				{/* Only show date/genre for Focus non-placeholders */}
				{dateGenreText && (
					<div class={s.synopsisTextHeader}>
						{dateGenreText}
					</div>
				)}

				{/* Synopsis Text/Body */}
				{super.renderSynopsis()}
			</div>
		);
	}

	renderCreditList(creditSection) {
		const hasCredits = creditSection.credits && creditSection.credits.length > 0;
		const credits = hasCredits ? creditSection.credits : [{ name: 'Add credits...' }];

		return (
			<div class={joinClasses(s.credit, !hasCredits && s.empty)}>
				<span>{credits.map((member) => member.name).join(', ')}</span>
			</div>
		);
	}

	renderVisual() {
		return (
			<SelectableSection class={s.wrapper} section="/pages/synopsis" {...this.props}>
				<div class={s.content}>
					{/* Onesheet/Poster */}
					{this.renderOnesheet()}

					{/* About Wrapper */}
					<div class={s.aboutWrapper}>
						<h3>About The Film</h3>
						<div class={s.about}>
							{/* Single Column: Synopsis + Credits */}
							<div class={s.aboutCol}>
								{/* Synopsis Text/Body */}
								{this.renderSynopsis()}

								{/* Credits Below Synopsis Text */}
								{this.renderCredits()}
							</div>
						</div>
					</div>
				</div>
			</SelectableSection>
		);
	}

	// ===============================
	// SETTINGS SIDEBAR
	// ===============================

	renderOnesheetSettings() {
		return (
			<div>
				<span>Onesheet can be edited from the movie page media tab.</span>
				<GoToMediaButton dark movie={this.movie} />
			</div>
		);
	}
}
